import React, { useEffect, useState, useCallback } from "react";
import TopNav from "../layouts/TopNav";
import { useLocation, Link, useNavigate } from "react-router-dom";
import "../Styles/genratedslip.css";
import { BsPencil } from "react-icons/bs";
import { toast, ToastContainer } from "react-toastify";
import logo from "../asset/Image/logo-.png";
import Swal from "sweetalert2";
import { CircularProgress } from "@mui/material";
import ReLoginModal from "../components/ReLoginModal";
import AllocationSelectModal from "../components/Modals/selectModal/AllocationSelectModal";
import api from "../util/axios";

type Requisition = {
  _id: string;
  approvalNumber: string;
  availableToBook: number;
  customer: {
    _id: string;
    businessName: string;
  };
  itemId: string;
  itemName: string;
  quantity: number;
  quantityToLoad: number;
  totalCost: number;
  unitPrice: number;
};

type Invoice = {
  loader: string;
  supplyLocation: string;
  destination: string;
  ullager: string;
  started: string;
  completed: string;
  meterBefore: string;
  meterAfter: string;
  Cfirst: string;
  Csecond: string;
  Cthird: string;
  Cfourth: string;
  Cfifth: string;
  Csixth: string;
  Cseventh: string;
  Ufirst: string;
  Usecond: string;
  Uthird: string;
  Ufourth: string;
  Ufifth: string;
  Usixth: string;
  Useventh: string;
  truckNumber: string;
  driver: string;
  driverNum: string;
  capacity: string;
  quantityLoaded: string;
};

type LoadingSlip = {
  _id: string;
  loadingNumber: string;
  truckNumber: string;
  supplyLocation: string;
  requisitions: Requisition[];
  selectMvt?: string;
  transporter?: string;
  selectedDriverDetails?: { driver: string };
  staff: { name: string, role: string };
  license: {
    _id: string;
    licenseNumber: string;
    licenseOwner: string;
    destination?: string;
  };
};

const applyPrintStyles = (
  slipElement: HTMLElement,
  printButtons: HTMLElement | null,
  editButton: HTMLElement | null
): {
  table: HTMLElement | null;
  tds: NodeListOf<HTMLElement>;
  inputs: NodeListOf<HTMLInputElement>;
  destinationInput: HTMLInputElement | null;
  qtyToBeLoadedCell: HTMLElement | null;
  qtyLoadedCell: HTMLElement | null;
  meterBeforeCell: HTMLElement | null;
  redStars: NodeListOf<HTMLElement>;
  logo: HTMLImageElement | null;
  waterMark: HTMLElement | null;
  waterMarkSpan: HTMLElement | null;
  generatedByText: HTMLElement | null;
} => {
  // Hide buttons during printing
  if (printButtons) printButtons.style.display = "none";
  if (editButton) editButton.style.display = "none";

  // Apply print-specific styles for 8x6.75 inch portrait
  slipElement.style.width = "203.2mm";
  slipElement.style.height = "171.45mm";
  slipElement.style.margin = "2mm";
  slipElement.style.padding = "2mm";
  slipElement.style.fontSize = "10px";
  slipElement.style.lineHeight = "1.2";
  slipElement.style.background = "#fff";
  slipElement.style.color = "#000";
  slipElement.style.fontFamily = "'Montserrat', sans-serif";
  slipElement.style.float = "none";
  slipElement.style.transform = "scale(1)";
  slipElement.style.overflow = "hidden";
  slipElement.style.boxSizing = "border-box";
  slipElement.style.position = "relative";

  const table = slipElement.querySelector("table") as HTMLElement | null;
  if (table) {
    table.style.width = "100%";
    table.style.height = "auto";
    table.style.border = "0.1px solid #000";
    table.style.marginBottom = "0";
    table.style.borderCollapse = "collapse";
    table.style.tableLayout = "fixed";
  }

  const tds = slipElement.querySelectorAll("table td") as NodeListOf<HTMLElement>;
  tds.forEach((td) => {
    td.style.border = "0.1px solid #000";
    td.style.padding = "1mm";
    td.style.fontSize = "10px";
    td.style.whiteSpace = "normal";
    td.style.overflow = "hidden";
    td.style.wordWrap = "break-word";
    td.style.boxSizing = "border-box";
  });

  const qtyToBeLoadedCell = slipElement.querySelector("td:nth-child(5):nth-last-child(7)") as HTMLElement | null;
  const qtyLoadedCell = slipElement.querySelector("td:nth-child(5):nth-last-child(6)") as HTMLElement | null;
  const meterBeforeCell = slipElement.querySelector("td:nth-child(5):nth-last-child(5)") as HTMLElement | null;

  if (qtyToBeLoadedCell) qtyToBeLoadedCell.style.width = "12%";
  if (qtyLoadedCell) qtyLoadedCell.style.width = "12%";
  if (meterBeforeCell) meterBeforeCell.style.width = "12%";

  const inputs = slipElement.querySelectorAll("input") as NodeListOf<HTMLInputElement>;
  inputs.forEach((input) => {
    input.style.display = "none";
    input.style.width = "100%";
    input.style.fontSize = "10px";
  });

  const destinationInput = slipElement.querySelector(".destination input") as HTMLInputElement | null;
  if (destinationInput) destinationInput.style.display = "none";

  const redStars = slipElement.querySelectorAll(".require_star") as NodeListOf<HTMLElement>;
  redStars.forEach((star) => {
    star.style.display = "none";
  });

  const logo = slipElement.querySelector("img.w-22.h-16") as HTMLImageElement | null;
  if (logo) {
    logo.style.width = "40mm";
    logo.style.height = "20mm";
  }

  const waterMark = slipElement.querySelector(".waterMark") as HTMLElement | null;
  let waterMarkSpan: HTMLElement | null = null;
  if (waterMark) {
    waterMark.style.position = "absolute";
    waterMark.style.top = "50mm";
    waterMark.style.left = "5mm";
    waterMark.style.transform = "rotate(-45deg)";
    waterMark.style.width = "auto";
    waterMark.style.textAlign = "left";
    waterMarkSpan = waterMark.querySelector("span") as HTMLElement | null;
    if (waterMarkSpan) {
      waterMarkSpan.style.fontSize = "25px";
      waterMarkSpan.style.opacity = "0.2";
    }
  }

  const generatedByText = slipElement.querySelector("p.text-blue-800") as HTMLElement | null;
  if (generatedByText) {
    generatedByText.style.fontSize = "6px";
  }

  return {
    table,
    tds,
    inputs,
    destinationInput,
    qtyToBeLoadedCell,
    qtyLoadedCell,
    meterBeforeCell,
    redStars,
    logo,
    waterMark,
    waterMarkSpan,
    generatedByText,
  };
};

const resetStyles = (
  slipElement: HTMLElement,
  printButtons: HTMLElement | null,
  editButton: HTMLElement | null,
  table: HTMLElement | null,
  tds: NodeListOf<HTMLElement>,
  inputs: NodeListOf<HTMLInputElement>,
  destinationInput: HTMLInputElement | null,
  qtyToBeLoadedCell: HTMLElement | null,
  qtyLoadedCell: HTMLElement | null,
  meterBeforeCell: HTMLElement | null,
  redStars: NodeListOf<HTMLElement>,
  logo: HTMLImageElement | null,
  waterMark: HTMLElement | null,
  waterMarkSpan: HTMLElement | null,
  generatedByText: HTMLElement | null
): void => {
  if (printButtons) printButtons.style.display = "block";
  if (editButton) editButton.style.display = "block";
  slipElement.style.cssText = "";
  if (table) table.style.cssText = "";
  tds.forEach((td) => (td.style.cssText = ""));
  inputs.forEach((input) => (input.style.cssText = ""));
  if (destinationInput) destinationInput.style.cssText = "";
  if (qtyToBeLoadedCell) qtyToBeLoadedCell.style.cssText = "";
  if (qtyLoadedCell) qtyLoadedCell.style.cssText = "";
  if (meterBeforeCell) meterBeforeCell.style.cssText = "";
  redStars.forEach((star) => (star.style.cssText = ""));
  if (logo) logo.style.cssText = "";
  if (waterMark) {
    waterMark.style.cssText = "";
    if (waterMarkSpan) waterMarkSpan.style.cssText = "";
  }
  if (generatedByText) generatedByText.style.cssText = "";
};

const GeneratedSlipNotInvoiced = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [reLogin, setReLogin] = useState(false);
  const details: LoadingSlip = location.state;
  // console.log("detallas:", details)
  const userRole = details?.staff?.role;

  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [invoiceComplete, setInvoiceComplete] = useState(false);
  const [licenseOwnerInput, setLicenseOwnerInput] = useState<string>("");
  const [customerNameInput, setCustomerNameInput] = useState<string>("");
  const [destination, setDestination] = useState<string>("");
  const [licenseOwner, setLicenseOwner] = useState<string>('');
  const [truckNumber, setTruckNumber] = useState<string>("");
  const [isAllocationModalOpen, setIsAllocationModalOpen] = useState(false);
  const [fields, setFields] = useState<{
    allocationId: string;
    allocationCustomer: string;
    licenseOwner: string;
    destination: string;
    truckNumber: string;
  }>({
    allocationId: "",
    allocationCustomer: "",
    licenseOwner: "",
    destination: "",
    truckNumber: "",
  });

  const handleSelectAllocation = useCallback(
    (allocationData: {
      _id: string;
      customer: { _id: string; businessName: string };
      license: {
        _id: string;
        licenseOwner: string;
        licenseId: string;
        licenseNumber: string;
      };
      destination: string;
      exDepotPrice: string;
      product?: { id: string; name: string; selling: number };
      programId: string;
      truckNumber: string;
      quantity?: string;
    }) => {
      setFields({
        allocationId: allocationData._id,
        allocationCustomer: allocationData.customer.businessName,
        licenseOwner: allocationData.license.licenseOwner,
        destination: allocationData.destination,
        truckNumber: allocationData.truckNumber || '',
      });
      setLicenseOwnerInput(allocationData.license.licenseNumber);
      setCustomerNameInput(allocationData.customer.businessName);
      setDestination(allocationData.destination);
      setLicenseOwner(allocationData.license.licenseOwner);
      setTruckNumber(allocationData.truckNumber);
      setIsAllocationModalOpen(false);
    },
    []
  );

  const [inv, setInv] = useState<Invoice>({
    loader: "",
    supplyLocation: "First Royal Oil Nigeria Limited",
    destination: "",
    ullager: "",
    started: "",
    completed: "",
    meterBefore: "",
    meterAfter: "",
    Cfirst: "",
    Csecond: "",
    Cthird: "",
    Cfourth: "",
    Cfifth: "",
    Csixth: "",
    Cseventh: "",
    Ufirst: "",
    Usecond: "",
    Uthird: "",
    Ufourth: "",
    Ufifth: "",
    Usixth: "",
    Useventh: "",
    truckNumber: details?.truckNumber || "",
    driver: details?.selectedDriverDetails?.driver || "",
    driverNum: "",
    capacity: "",
    quantityLoaded: "",
  });

  const [currentDateTime, setCurrentDateTime] = useState("");

  const updateSlip = () => {
    const originalTruckNumber = details?.truckNumber;
    const updatedTruckNumber = inv.truckNumber;
    const slipId = details?._id;
    if (originalTruckNumber !== updatedTruckNumber) {
      api
        .patch(
          `/loading-slip/reprint/${slipId}`,
          {
            truckNumber: updatedTruckNumber,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${window.localStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          // console.log("Truck number updated successfully:", res.data);
        })
        .catch((err) => {
          if (err.response?.data?.message === "jwt expired" || err.response?.data?.message === "jwt malformed") {
            setReLogin(true);
          } else {
            setReLogin(false);
          }
          toast.error(err.response.data.message);
        });
    }
  };

  const printSlip = (): void => {
    const slipElement = document.querySelector(".generatedSlip") as HTMLElement | null;
    const printButtons = document.querySelector(".print") as HTMLElement | null;
    const editButton = document.querySelector(".editText") as HTMLElement | null;

    if (!slipElement) {
      console.error("Slip element (.generatedSlip) not found in the DOM.");
      return;
    }

    // Apply print styles to original slip
    const {
      table,
      tds,
      inputs,
      destinationInput,
      qtyToBeLoadedCell,
      qtyLoadedCell,
      meterBeforeCell,
      redStars,
      logo,
      waterMark,
      waterMarkSpan,
      generatedByText,
    } = applyPrintStyles(slipElement, printButtons, editButton);

    // Create a temporary container for printing
    const printContainer = document.createElement("div");
    printContainer.className = "print-container";
    printContainer.style.position = "absolute";
    printContainer.style.top = "0";
    printContainer.style.left = "0";
    printContainer.style.width = "203.2mm";
    printContainer.style.height = "171.45mm";
    printContainer.style.zIndex = "1000";
    const clonedSlip = slipElement.cloneNode(true) as HTMLElement;
    clonedSlip.className = "generatedSlip cloned-slip";

    const clonedWaterMark = clonedSlip.querySelector(".waterMark") as HTMLElement | null;
    if (clonedWaterMark) {
      clonedWaterMark.style.position = "absolute";
      clonedWaterMark.style.top = "120mm";
      clonedWaterMark.style.left = "-15mm";
      clonedWaterMark.style.transform = "rotate(-45deg)";
      clonedWaterMark.style.width = "auto";
      clonedWaterMark.style.textAlign = "left";
      clonedWaterMark.style.zIndex = "1";
      clonedWaterMark.style.pointerEvents = "none";
      clonedWaterMark.style.color = "#000";
      const clonedWaterMarkSpan = clonedWaterMark.querySelector("span") as HTMLElement | null;
      if (clonedWaterMarkSpan) {
        clonedWaterMarkSpan.style.fontSize = "45px";
        clonedWaterMarkSpan.style.opacity = "0.3";
        clonedWaterMarkSpan.style.fontWeight = "bold";
        clonedWaterMarkSpan.style.color = "#000";
      }
    }

    printContainer.appendChild(clonedSlip);
    document.body.appendChild(printContainer);

    slipElement.style.visibility = "hidden";

    updateSlip();

    window.print();

    setTimeout(() => {
      slipElement.style.visibility = "visible";
      resetStyles(
        slipElement,
        printButtons,
        editButton,
        table,
        tds,
        inputs,
        destinationInput,
        qtyToBeLoadedCell,
        qtyLoadedCell,
        meterBeforeCell,
        redStars,
        logo,
        waterMark,
        waterMarkSpan,
        generatedByText
      );
      document.body.removeChild(printContainer);
      navigate("/dashboard/notinvoiced");
    }, 300);
  };

  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const hours = String(today.getHours()).padStart(2, "0");
    const minutes = String(today.getMinutes()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;
    setCurrentDateTime(formattedDate);
  }, []);

  const token = window.localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleChange = ({ target: { name, value } }: React.ChangeEvent<HTMLInputElement>) => {
    setInv((prevInv) => {
      let updatedInv = { ...prevInv, [name]: value };

      if (name === "meterBefore" || name === "quantityLoaded") {
        const meterBefore = parseFloat(updatedInv.meterBefore || "0");
        const totalQuantityLoaded = parseFloat(updatedInv.quantityLoaded || "0");
        updatedInv.meterAfter = (meterBefore + totalQuantityLoaded).toFixed(2);
      }

      return updatedInv;
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const totalQuantityToLoad = details?.requisitions?.reduce(
      (acc: number, req: Requisition) => acc + req.quantityToLoad,
      0
    );

    const totalCompartmentVolume = [
      inv.Cfirst,
      inv.Csecond,
      inv.Cthird,
      inv.Cfourth,
      inv.Cfifth,
      inv.Csixth,
      inv.Cseventh,
    ].reduce((acc, val) => acc + (parseFloat(val) || 0), 0);

    if (totalCompartmentVolume !== totalQuantityToLoad) {
      Swal.fire({
        title: "Error!",
        text: `Total value in compartments (${totalCompartmentVolume}) should be equal to Quantity To Be Loaded (${totalQuantityToLoad}).`,
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "red",
        confirmButtonText: "Try Again",
      });
      return;
    }

    const totalQuantityLoaded = parseFloat(inv.quantityLoaded || "0");

    if (totalQuantityLoaded !== totalQuantityToLoad) {
      Swal.fire({
        title: "Error!",
        text: `Total Quantity Loaded (${totalQuantityLoaded}) must be equal to Quantity To Load (${totalQuantityToLoad}).`,
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "red",
        confirmButtonText: "Try Again",
      });
      return;
    }

    const meterBefore = parseFloat(inv.meterBefore);
    const meterAfter = parseFloat(inv.meterAfter);

    if (meterAfter - meterBefore !== totalQuantityLoaded) {
      Swal.fire({
        title: "Error!",
        text: `Difference between Meter After (${meterAfter}) and Meter Before (${meterBefore}) should be equal to Total Quantity Loaded (${totalQuantityLoaded}).`,
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "red",
        confirmButtonText: "Try Again",
      });
      return;
    }

    const distributedQuantities = details?.requisitions?.map((req: Requisition) => {
      const proportion = totalQuantityToLoad > 0 ? req.quantityToLoad / totalQuantityToLoad : 0;
      return {
        ...req,
        quantityLoaded: totalQuantityToLoad > 0 ? (totalQuantityLoaded * proportion).toFixed(2) : "0",
      };
    });

    setLoading(true);

    const payload = {
      supplyLocation: inv.supplyLocation,
      destination: destination ? licenseOwner + destination : inv.destination,
      loader: inv.loader,
      ullager: inv.ullager,
      loadingTime: {
        started: inv.started,
        completed: inv.completed,
      },
      meterBefore: inv.meterBefore,
      meterAfter: inv.meterAfter,
      compartmentNo: {
        first: inv.Cfirst,
        second: inv.Csecond,
        third: inv.Cthird,
        fourth: inv.Cfourth,
        fifth: inv.Cfifth,
        sixth: inv.Csixth,
        seventh: inv.Cseventh,
      },
      ullage: {
        first: inv.Ufirst,
        second: inv.Usecond,
        third: inv.Uthird,
        fourth: inv.Ufourth,
        fifth: inv.Ufifth,
        sixth: inv.Usixth,
        seventh: inv.Useventh,
      },
      requisitions: distributedQuantities.map((req: Requisition & { quantityLoaded: string }) => ({
        approvalNumber: req.approvalNumber,
        availableToBook: req.availableToBook,
        customer: req.customer,
        businessName: req.customer.businessName,
        itemId: req.itemId,
        itemName: req.itemName,
        quantity: req.quantity,
        quantityLoaded: parseFloat(req.quantityLoaded),
        quantityToLoad: req.quantityToLoad,
        totalCost: req.totalCost,
        unitPrice: req.unitPrice,
        _id: req._id,
      })),
      transporter: details?.selectMvt,
      truckNumber: inv.truckNumber,
      driver: details?.transporter === "SELF COLLECTION" ? inv.driver : details?.selectedDriverDetails?.driver,
      capacity: inv.capacity,
      invoiced: invoiceComplete,
      ...(fields.allocationId && fields.allocationId.trim() !== "" ? { dailyAllocation: fields.allocationId } : {}),
    }

    if (!details._id) {
      Swal.fire({
        title: "Error!",
        text: "Missing slip ID. Cannot submit the form.",
        icon: "error",
        confirmButtonColor: "red",
        confirmButtonText: "OK",
      });
      setLoading(false);
      return;
    }

    api
      .patch(
        `/loading-slip/${details?._id}`, payload, { headers }
      )
      .then((res) => {
        // console.log("my payload", payload);
        // console.log("payload sent", res.data);
        setLoading(false);
        Swal.fire({
          title: "Success!",
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setTimeout(() => {
          navigate("/dashboard/invoicetable");
        }, 3000);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response?.data?.message === "jwt expired" || err.response?.data?.message === "jwt malformed") {
          toast.error('Session expired, please log in again.');
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        Swal.fire({
          title: "Error!",
          text: `${err.response?.data?.message || "An error occurred"}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
      });
  };

  const businessName = details?.requisitions?.[0]?.customer.businessName || "Business Name Unavailable";
  const loadingNumber = details?.loadingNumber || "N/A";
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const hours = String(today.getHours()).padStart(2, "0");
  const minutes = String(today.getMinutes()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;

  useEffect(() => {
    if (truckNumber.length > 1) {
      if (inv.truckNumber.toLowerCase() !== truckNumber.toLowerCase()) {
        Swal.fire({
          title: "Truck Number Mismatch",
          text: `The truck number in the slip (${inv.truckNumber}) does not match the truck number in the Daily Allocation (${truckNumber}). Please update the slip.`,
          icon: "warning",
          confirmButtonColor: "red",
          // confirmButtonText: "Update Slip",
        })
      }
    }
  }, [truckNumber, inv.truckNumber]);

  return (
    <>
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-container .cloned-slip, .print-container .cloned-slip * {
              visibility: visible;
            }
            .print-container .cloned-slip {
              position: absolute;
              left: 0;
              top: 0;
              width: 203.2mm;
              height: 171.45mm;
            }
            .generatedSlip {
              visibility: hidden !important;
            }
            .waterMark {
              position: absolute;
              top: 120mm;
              left: -15mm;
              transform: rotate(-45deg);
              width: auto ваших;
              text-align: left;
              z-index: 1;
              pointer-events: none;
              color: #000;
            }
            .waterMark span {
              font-size: 45px;
              opacity: 0.3;
              font-weight: bold;
              color: #000;
            }
          }
        `}
      </style>
      <div className="board">
        {reLogin ? <ReLoginModal /> : null}
        <ToastContainer />
        <TopNav title="Loading Slip" />
        <form onSubmit={handleSubmit} className="generatedSlip">
          <span
            onClick={() => setIsEditing(!isEditing)}
            className={`editText ${isEditing ? "" : "opaque"}`}
          >
            <BsPencil /> Edit
          </span>
          <div className="topDetails pb-2">
            <h2 style={{ fontSize: "14px" }}>{businessName}</h2>
            <p style={{ fontSize: "12px" }}>Loading slip No: {loadingNumber}</p>
          </div>

          <table>
            <tr className="compa">
              <td colSpan={2}>
                Supply Location: {inv.supplyLocation}
              </td>
              <td colSpan={5}></td>
              <td colSpan={3} rowSpan={2}>
                <img className="w-22 h-16" src={logo} alt="" />
              </td>
            </tr>
            <tr className="compa">
              <td colSpan={2}>
                Approval No: {details?.requisitions?.map((num: Requisition) => num.approvalNumber).join(" / ") || "N/A"}
              </td>
              <td colSpan={5}>
                Product: {details?.requisitions?.[0]?.itemName || "N/A"}
              </td>
            </tr>
            <tr className="compa">
              <td colSpan={4}>Customer: {businessName}</td>
              <td colSpan={3}>
                <span>QTY TO BE LOADED: </span>
                <strong className="text-sm font-extrabold">
                  {details?.requisitions?.reduce((acc: number, req: Requisition) => acc + req.quantityToLoad, 0) || 0}
                </strong>
              </td>
              <td rowSpan={3} colSpan={2}>
                SPECIFY TANK OR SUB INVENTORY PRODUCT WAS LOADED FROM BELOW
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr className="compa">
              <td className="destination" colSpan={4}>
                Destination: <span className="require_star">*</span> {licenseOwner + destination}
                <input
                  required
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="destination"
                  value={destination ? licenseOwner + destination : inv.destination}
                  onChange={handleChange}
                />
              </td>
              <td colSpan={3}>
                QTY LOADED: <span className="require_star">*</span>
                <input
                  required
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="number"
                  name="quantityLoaded"
                  value={inv.quantityLoaded || ""}
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr className="compa">
              <td colSpan={4}>
                TIME OF BRV ARRIVAL AT IN-GATE
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="time"
                  onChange={handleChange}
                />
              </td>
              <td colSpan={3}>
                METER BEFORE: <span className="require_star">*</span>
                <input
                  required
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="number"
                  name="meterBefore"
                  value={inv.meterBefore}
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr className="compa">
              <td rowSpan={2} colSpan={1}>
                SECURITY ALLOW BRV
              </td>
              <td colSpan={5}>
                Driver's Name: <span className="require_star">*</span>
                <input
                  required
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="driver"
                  value={inv.driver}
                  onChange={handleChange}
                />
              </td>
              <td colSpan={3}>
                METER AFTER:
                <input
                  type="number"
                  name="meterAfter"
                  value={inv.meterAfter}
                  readOnly
                  className="read-only"
                />
              </td>
            </tr>
            <tr className="compa">
              <td colSpan={5}>
                Loader's Name: <span className="require_star">*</span>
                <input
                  required
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="loader"
                  value={inv.loader}
                  onChange={handleChange}
                />
              </td>
              <td colSpan={3}>
                TIME LOADING STARTED:
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  name="started"
                  value={inv.started || currentDateTime}
                  onChange={handleChange}
                  type="datetime-local"
                />
              </td>
            </tr>
            <tr className="compa">
              <td colSpan={1}>
                Capacity:
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="capacity"
                  value={inv.capacity}
                  onChange={handleChange}
                />
              </td>
              <td colSpan={4}>
                <span>Truck Number: </span><strong className="text-sm font-extrabold">{inv.truckNumber}</strong>
                {isEditing && userRole === "admin" && (
                  <input
                    required
                    readOnly={false}
                    className="editable"
                    type="text"
                    name="truckNumber"
                    value={inv.truckNumber}
                    onChange={handleChange}
                    style={{ display: isEditing && userRole === "admin" ? "inline" : "none" }}
                  />
                )}
              </td>
              <td colSpan={5}>
                TIME LOADING ENDED:
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  name="completed"
                  value={inv.completed || currentDateTime}
                  onChange={handleChange}
                  type="datetime-local"
                />
              </td>
            </tr>
            <tr className="compa">
              <td colSpan={4}>
                ULLAGER’S NAME <span className="require_star">*</span>
                <input
                  required
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="ullager"
                  value={inv.ullager}
                  onChange={handleChange}
                />
              </td>
              <td colSpan={3}>
                ULLAGE TIME
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  name="completed"
                  value={inv.completed || currentDateTime}
                  onChange={handleChange}
                  type="datetime-local"
                />
              </td>
              <td colSpan={3}>
                C OF Q NO
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="number"
                />
              </td>
            </tr>
            <tr className="compa volumeSpace">
              <td>COMPARTMENT NO:</td>
              <td>1</td>
              <td>2</td>
              <td>3</td>
              <td>4</td>
              <td>5</td>
              <td>6</td>
              <td>7</td>
              <td>
                BATCH
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="number"
                />
              </td>
            </tr>
            <tr className="compa rowSpace">
              <td colSpan={1}>COMPARTMENT VOL IN LTR: <span className="require_star">*</span></td>
              <td rowSpan={1}>
                <input
                  required
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Cfirst"
                  value={inv.Cfirst}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Csecond"
                  value={inv.Csecond}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Cthird"
                  value={inv.Cthird}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Cfourth"
                  value={inv.Cfourth}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Cfifth"
                  value={inv.Cfifth}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Csixth"
                  value={inv.Csixth}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Cseventh"
                  value={inv.Cseventh}
                  onChange={handleChange}
                />
              </td>
              <td rowSpan={1} colSpan={1}>
                S.G
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                />
              </td>
            </tr>
            <tr className="compa">
              <td colSpan={1}>ULLAGE <span className="require_star">*</span></td>
              <td colSpan={1}>
                <input
                  required
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Ufirst"
                  value={inv.Ufirst}
                  onChange={handleChange}
                />
              </td>
              <td colSpan={1}>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Usecond"
                  value={inv.Usecond}
                  onChange={handleChange}
                />
              </td>
              <td colSpan={1}>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Uthird"
                  value={inv.Uthird}
                  onChange={handleChange}
                />
              </td>
              <td colSpan={1}>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  name="Ufourth"
                  value={inv.Ufourth}
                  type="text"
                  onChange={handleChange}
                />
              </td>
              <td colSpan={1}>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Ufifth"
                  value={inv.Ufifth}
                  onChange={handleChange}
                />
              </td>
              <td colSpan={1}>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Usixth"
                  value={inv.Usixth}
                  onChange={handleChange}
                />
              </td>
              <td colSpan={1}>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                  name="Useventh"
                  value={inv.Useventh}
                  onChange={handleChange}
                />
              </td>
              <td colSpan={3}>
                ACTUAL TEMP
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                />
              </td>
            </tr>
            <tr className="compa">
              <td colSpan={1}>Seal</td>
              <td colSpan={2}>
                Seal No
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="number"
                />
              </td>
              <td colSpan={4}>
                invoice generated time:
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  name="started"
                  value={inv.started || currentDateTime}
                  onChange={handleChange}
                  type="datetime-local"
                />
              </td>
              <td colSpan={4}>brv out time</td>
            </tr>
            <div className="waterMark">
              <span>{details?.requisitions?.[0]?.itemName || "N/A"}</span>
            </div>
            <tr className="compa">
              <td colSpan={2}>Y/N</td>
              <td colSpan={2}>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                />
              </td>
              <td colSpan={4}>
                invoice Signed time:
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  name="completed"
                  value={inv.completed || currentDateTime}
                  onChange={handleChange}
                  type="datetime-local"
                />
              </td>
              <td colSpan={4}>
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                />
              </td>
            </tr>
            <tr>
              <td className="pb-5" colSpan={2}>
                gate entry authorisation
                <input
                  readOnly={!isEditing}
                  className={isEditing ? "editable" : ""}
                  type="text"
                />
              </td>
              <td colSpan={8}>
                <table>
                  <tr>
                    <th>signature</th>
                    <th>SLIP DATE</th>
                    <th>{formattedDate}</th>
                  </tr>
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <p className="w-full text-blue-800">generated by {details.staff.name}</p>

          {isEditing ? (
            <div
              className="print"
              style={{
                justifyContent: "flex-left",
                flexDirection: "column",
                alignItems: "flex-left",
              }}
            >
              <div className="checks">
                <input
                  required
                  type="checkbox"
                  checked={invoiceComplete}
                  onChange={() => setInvoiceComplete(!invoiceComplete)}
                />
                <span>Invoice Complete (Click only when you fill all the input)</span>
              </div>
              <button type="submit" className="catBtn11">
                {loading ? (
                  <CircularProgress
                    style={{
                      color: "#fff",
                      backgroundColor: "transparent",
                      // width: "20px",
                      // height: "20px",
                    }}
                  />
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          ) : null}

          <div className="print">
            <button type="button" onClick={() => { setIsEditing(false); printSlip(); }}>
              Print Slip
            </button>
            <Link to="/dashboard/notinvoiced">close</Link>
          </div>

          <div className="ml-32 input lsInput allocationDiv print">
            <label>Attach Daily Allocation</label>
            <input
              type="text"
              name="licenseNumber"
              value={fields.allocationId ? licenseOwnerInput : ""}
              readOnly
            />
            <p>{licenseOwnerInput} | {customerNameInput}</p>
            <button
              type="button"
              className="ml-2 outline-none cursor-pointer bg-gray-200 px-2 py-1 rounded"
              onClick={() => setIsAllocationModalOpen(true)}
            >
              Select allocation
            </button>
          </div>
        </form>
        <AllocationSelectModal
          open={isAllocationModalOpen}
          onClose={() => setIsAllocationModalOpen(false)}
          onSelect={handleSelectAllocation}
        />
      </div>
    </>
  );
};

export default GeneratedSlipNotInvoiced;